module.exports = __webpack_public_path__ + "media/slider.f76cf9db.webm";